// extracted by mini-css-extract-plugin
export default {"container":"LoanParameters_container__kRkuk"};